import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  it: {
    brand: "La Caffetteria del Fortino",
    tagline: "Caffè, aperitivi e timbri digitali",
    login_title: "Il tuo bar, in tasca",
    login_subtitle: "Ordina dal tavolo, colleziona timbri e guadagna caffè omaggio.",
    login_google: "Accedi con Google",
    feat_menu: "Menu digitale con QR al tavolo",
    feat_stamps: "10 timbri = 1 caffè omaggio",
    feat_orders: "Segui il tuo ordine in tempo reale",
    nav_menu: "Menu",
    nav_loyalty: "Carta fedeltà",
    nav_orders: "Ordini",
    nav_staff: "Area Staff",
    customer_view: "Vista cliente",
    logout: "Esci",
    table: "Tavolo",
    select_table: "Scegli tavolo",
    table_modal_title: "Seleziona il tuo tavolo",
    cat_all: "Tutto",
    cat_caffe: "Caffetteria",
    cat_dolci: "Dolci",
    cat_aperitivi: "Aperitivi",
    cat_bevande: "Bevande",
    add_to_cart: "Aggiungi",
    added: "Aggiunto al carrello",
    cart_title: "Il tuo ordine",
    cart_empty: "Il carrello è vuoto",
    note_placeholder: "Note per il barista (opzionale)",
    total: "Totale",
    place_order: "Invia ordine",
    order_placed: "Ordine inviato! Lo stiamo preparando.",
    need_table: "Seleziona prima il tavolo",
    stamps_title: "Carta Fedeltà",
    stamps_subtitle: "Ogni caffè completato vale un timbro. Al traguardo, riscatta l'omaggio!",
    stamps_of: "timbri su",
    claim_reward: "Riscatta omaggio",
    reward_claimed: "Premio riscattato! Mostra questa schermata al banco.",
    rewards_count: "Premi riscattati",
    orders_title: "I tuoi ordini",
    no_orders: "Nessun ordine ancora",
    status_pending: "In attesa",
    status_preparing: "In preparazione",
    status_ready: "Pronto",
    status_completed: "Completato",
    queue: "Coda ordini",
    menu_mgmt: "Gestione menu",
    analytics: "Statistiche",
    tables_qr: "QR Tavoli",
    add_item: "Nuovo articolo",
    edit_item: "Modifica articolo",
    name_it: "Nome (IT)",
    name_en: "Nome (EN)",
    desc_it: "Descrizione (IT)",
    desc_en: "Descrizione (EN)",
    price: "Prezzo",
    category: "Categoria",
    image_url: "URL immagine",
    available: "Disponibile",
    stamps_eligible: "Vale un timbro",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    item_saved: "Articolo salvato",
    item_deleted: "Articolo eliminato",
    revenue_total: "Incasso totale",
    revenue_today: "Incasso oggi",
    orders_total: "Ordini totali",
    orders_today: "Ordini oggi",
    avg_order: "Scontrino medio",
    customers_total: "Clienti registrati",
    top_items: "Più venduti",
    orders_by_day: "Ordini ultimi 7 giorni",
    orders_by_hour: "Ordini per ora",
    copy_link: "Copia link",
    link_copied: "Link copiato",
    loading: "Caricamento...",
    empty_queue: "Nessun ordine in questo stato",
    move_to: "Sposta in",
    items: "articoli",
    order_from: "Ordine di",
    staff_dashboard: "Dashboard Staff",
    scan_hint: "Inquadra il QR al tavolo o seleziona il numero",
    sold: "venduti",
    delete_order: "Elimina ordine",
    order_deleted: "Ordine eliminato",
    cancel_order: "Annulla ordine",
    order_cancelled: "Ordine annullato",
    review_title: "Lasciaci una recensione",
    review_subtitle: "Inquadra il QR code e raccontaci la tua esperienza. Ci aiuti a crescere!",
    review_open_link: "oppure apri la pagina recensioni",
    pay_paid: "Pagato",
    pay_paid_full: "Pagamento effettuato",
    pay_unpaid: "Da pagare",
    mark_paid: "Pagamento in sospeso",
    mark_unpaid: "Pagamento effettuato",
    payment_updated: "Pagamento aggiornato",
    print_qr_title: "Stampa i QR dei tavoli",
    print_qr_desc: "PDF pronto per la stampa (A4, 4 tavoli per pagina) con i 12 QR collegati a lacaffetteriadelfortino.it",
    download_pdf: "Scarica PDF",
    orders_paid_closed: "ordini pagati e chiusi",
    orders_short: "ordini",
    table_bill_hint: "Il pagamento chiude tutti gli ordini del tavolo",
    order_closed_paid: "Ordine chiuso – pagato ✓",
    order_closed_desc: "Grazie! Torni al menu tra pochi secondi.",
    reset_rewards: "Azzera premi",
    rewards_reset: "Premi azzerati",
    hero_photo: "Foto pagina iniziale",
    change_photo: "Cambia foto",
    reset_photo: "Ripristina",
    hero_saved: "Foto aggiornata",
    hero_reset: "Foto predefinita ripristinata",
    new_order_alert: "Nuovo ordine!",
    sound_on: "Suono attivo",
    sound_off: "Suono disattivato",
    radio_title: "Radio del gestore",
    radio_none: "Nessuna radio",
    radio_custom: "Oppure inserisci una tua radio (link streaming):",
    radio_name_ph: "Nome radio",
    radio_error: "Impossibile riprodurre questa radio",
    opening_hours: "Orari di apertura",
    open_now: "Aperto ora",
    closed_now: "Chiuso",
    closed_day: "Chiuso",
    closed_order_blocked: "Il bar è chiuso: gli ordini riapriranno negli orari di apertura",
    promo_of_day: "Promo del giorno",
    promo_price: "Prezzo promo (€)",
    promo_hint: "Prezzo normale:",
    promo_saved: "Promo del giorno attivata",
    promo_removed: "Promo rimossa",
    order_ready_alert: "Il tuo ordine è pronto!",
    order_ready_body: "Passa al banco o attendi al tavolo.",
    revenue_30d: "Incassi ultimi 30 giorni",
    export_excel: "Esporta mese in Excel",
    download: "Scarica",
    export_done: "File Excel scaricato",
    birthday_prompt: "Quando è il tuo compleanno?",
    birthday_bonus_hint: "Il giorno del tuo compleanno ricevi un timbro extra con il primo ordine!",
    birthday_saved: "Compleanno salvato",
    birthday_label: "Compleanno",
    birthday_today_title: "Buon compleanno! 🎂",
    birthday_today_desc: "Oggi il tuo primo ordine vale un timbro in più.",
    to_collect: "Da incassare",
    people: "Persone",
    cover: "Coperto",
    cover_per_person: "Coperto a persona (€)",
    subtotal: "Subtotale",
    view_by_status: "Per stato",
    view_by_table: "Per tavolo",
    no_active_tables: "Nessuna comanda attiva",
    advance_all: "Avanza tutto",
    complete_table: "Completa comanda",
    mark_all_paid: "Pagamento in sospeso",
    mark_all_unpaid: "Pagamento effettuato",
    customers: "Clienti",
    customer_col: "Cliente",
    stamps_col: "Timbri",
    rewards_col: "Premi riscattati",
    no_customers: "Nessun cliente registrato",
    reset_stats: "Azzera statistiche",
    reset_confirm_title: "Azzerare le statistiche?",
    reset_confirm_desc: "Verranno eliminati TUTTI gli ordini (incassi, grafici e vendite tornano a zero). I timbri dei clienti restano invariati.",
    confirm: "Conferma",
    stats_reset: "Statistiche azzerate",
    settings_saved: "Impostazioni salvate",
    scan_qr_hint: "Scansiona il QR del tavolo per ordinare",
    loyalty_settings: "Impostazioni carta fedeltà",
    reward_name: "Omaggio",
    stamps_goal: "Timbri per l'omaggio",
    redeem_reward: "Riscatta omaggio",
    rewards_pending_col: "Da consegnare",
    deliver_reward: "Consegnato",
    delete_customer: "Elimina",
    delete_customer_confirm: "Eliminare questo cliente? Verranno cancellati account, ordini, timbri e premi.",
    customer_deleted: "Cliente eliminato",
    redeemed_marked: "Omaggio riscattato: ora in 'Da consegnare'",
    delivered_marked: "Omaggio consegnato",
    reset_customers: "Azzera clienti",
    reset_customers_title: "Azzerare i clienti registrati?",
    reset_customers_desc: "Verranno eliminati tutti gli account cliente con timbri e premi. Gli ordini restano nelle statistiche.",
    customers_reset: "Clienti azzerati",
  },
  en: {
    brand: "La Caffetteria del Fortino",
    tagline: "Coffee, aperitifs and digital stamps",
    login_title: "Your bar, in your pocket",
    login_subtitle: "Order from your table, collect stamps and earn free coffee.",
    login_google: "Sign in with Google",
    feat_menu: "Digital menu with table QR code",
    feat_stamps: "10 stamps = 1 free coffee",
    feat_orders: "Track your order in real time",
    nav_menu: "Menu",
    nav_loyalty: "Loyalty card",
    nav_orders: "Orders",
    nav_staff: "Staff Area",
    customer_view: "Customer view",
    logout: "Log out",
    table: "Table",
    select_table: "Select table",
    table_modal_title: "Select your table",
    cat_all: "All",
    cat_caffe: "Coffee",
    cat_dolci: "Sweets",
    cat_aperitivi: "Aperitifs",
    cat_bevande: "Drinks",
    add_to_cart: "Add",
    added: "Added to cart",
    cart_title: "Your order",
    cart_empty: "Your cart is empty",
    note_placeholder: "Notes for the barista (optional)",
    total: "Total",
    place_order: "Place order",
    order_placed: "Order sent! We're preparing it.",
    need_table: "Please select a table first",
    stamps_title: "Loyalty Card",
    stamps_subtitle: "Every completed coffee earns a stamp. Reach the goal and claim your reward!",
    stamps_of: "stamps out of",
    claim_reward: "Claim reward",
    reward_claimed: "Reward claimed! Show this screen at the counter.",
    rewards_count: "Rewards claimed",
    orders_title: "Your orders",
    no_orders: "No orders yet",
    status_pending: "Pending",
    status_preparing: "Preparing",
    status_ready: "Ready",
    status_completed: "Completed",
    queue: "Order queue",
    menu_mgmt: "Menu management",
    analytics: "Analytics",
    tables_qr: "Table QRs",
    add_item: "New item",
    edit_item: "Edit item",
    name_it: "Name (IT)",
    name_en: "Name (EN)",
    desc_it: "Description (IT)",
    desc_en: "Description (EN)",
    price: "Price",
    category: "Category",
    image_url: "Image URL",
    available: "Available",
    stamps_eligible: "Earns a stamp",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    item_saved: "Item saved",
    item_deleted: "Item deleted",
    revenue_total: "Total revenue",
    revenue_today: "Revenue today",
    orders_total: "Total orders",
    orders_today: "Orders today",
    avg_order: "Avg. order",
    customers_total: "Registered customers",
    top_items: "Best sellers",
    orders_by_day: "Orders last 7 days",
    orders_by_hour: "Orders by hour",
    copy_link: "Copy link",
    link_copied: "Link copied",
    loading: "Loading...",
    empty_queue: "No orders in this state",
    move_to: "Move to",
    items: "items",
    order_from: "Order by",
    staff_dashboard: "Staff Dashboard",
    scan_hint: "Scan the table QR code or pick a number",
    sold: "sold",
    delete_order: "Delete order",
    order_deleted: "Order deleted",
    cancel_order: "Cancel order",
    order_cancelled: "Order cancelled",
    review_title: "Leave us a review",
    review_subtitle: "Scan the QR code and tell us about your experience. It helps us grow!",
    review_open_link: "or open the review page",
    pay_paid: "Paid",
    pay_paid_full: "Payment received",
    pay_unpaid: "To pay",
    mark_paid: "Payment pending",
    mark_unpaid: "Payment received",
    order_closed_paid: "Order closed – paid ✓",
    order_closed_desc: "Thank you! Back to the menu in a few seconds.",
    reset_rewards: "Reset rewards",
    rewards_reset: "Rewards reset",
    hero_photo: "Home page photo",
    change_photo: "Change photo",
    reset_photo: "Reset",
    hero_saved: "Photo updated",
    hero_reset: "Default photo restored",
    new_order_alert: "New order!",
    sound_on: "Sound on",
    sound_off: "Sound off",
    radio_title: "Staff radio",
    radio_none: "No radio",
    radio_custom: "Or enter your own radio (stream link):",
    radio_name_ph: "Radio name",
    radio_error: "Cannot play this radio",
    opening_hours: "Opening hours",
    open_now: "Open now",
    closed_now: "Closed",
    closed_day: "Closed",
    closed_order_blocked: "We're closed: orders reopen during opening hours",
    promo_of_day: "Deal of the day",
    promo_price: "Promo price (€)",
    promo_hint: "Regular price:",
    promo_saved: "Deal of the day activated",
    promo_removed: "Deal removed",
    order_ready_alert: "Your order is ready!",
    order_ready_body: "Come to the counter or wait at your table.",
    revenue_30d: "Revenue – last 30 days",
    export_excel: "Export month to Excel",
    download: "Download",
    export_done: "Excel file downloaded",
    birthday_prompt: "When is your birthday?",
    birthday_bonus_hint: "On your birthday you get an extra stamp with your first order!",
    birthday_saved: "Birthday saved",
    birthday_label: "Birthday",
    birthday_today_title: "Happy birthday! 🎂",
    birthday_today_desc: "Today your first order earns an extra stamp.",
    payment_updated: "Payment updated",
    print_qr_title: "Print table QR codes",
    print_qr_desc: "Print-ready PDF (A4, 4 tables per page) with the 12 QR codes linked to lacaffetteriadelfortino.it",
    download_pdf: "Download PDF",
    orders_paid_closed: "orders paid and closed",
    orders_short: "orders",
    table_bill_hint: "Payment closes all orders at the table",
    to_collect: "To collect",
    people: "People",
    cover: "Cover",
    cover_per_person: "Cover per person (€)",
    subtotal: "Subtotal",
    view_by_status: "By status",
    view_by_table: "By table",
    no_active_tables: "No active tables",
    advance_all: "Advance all",
    complete_table: "Complete table",
    mark_all_paid: "Payment pending",
    mark_all_unpaid: "Payment received",
    customers: "Customers",
    customer_col: "Customer",
    stamps_col: "Stamps",
    rewards_col: "Rewards claimed",
    no_customers: "No customers yet",
    reset_stats: "Reset stats",
    reset_confirm_title: "Reset statistics?",
    reset_confirm_desc: "ALL orders will be deleted (revenue, charts and sales go back to zero). Customer stamps are kept.",
    confirm: "Confirm",
    stats_reset: "Stats reset",
    settings_saved: "Settings saved",
    scan_qr_hint: "Scan your table's QR code to order",
    loyalty_settings: "Loyalty card settings",
    reward_name: "Reward",
    stamps_goal: "Stamps per reward",
    redeem_reward: "Redeem reward",
    rewards_pending_col: "To deliver",
    deliver_reward: "Delivered",
    delete_customer: "Delete",
    delete_customer_confirm: "Delete this customer? Their account, orders, stamps and rewards will be removed.",
    customer_deleted: "Customer deleted",
    redeemed_marked: "Reward redeemed: now in 'To deliver'",
    delivered_marked: "Reward delivered",
    reset_customers: "Reset customers",
    reset_customers_title: "Reset registered customers?",
    reset_customers_desc: "All customer accounts with stamps and rewards will be deleted. Orders stay in statistics.",
    customers_reset: "Customers reset",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "it");
  const changeLang = (l) => {
    localStorage.setItem("lang", l);
    setLang(l);
  };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const t = (key) => translations[lang][key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
